export class MultiFactoryHelperProps {}

export const InitialMultiFactoryHelperProps: MultiFactoryHelperProps = <MultiFactoryHelperProps>{};